import React from "react";

/**
 * Status colour mapping per DESIGN_STANDARDS.md section 11:
 *   Draft    → amber  (Pending / Draft / In Progress)
 *   Approved → indigo (Submitted / Admin)
 *   Paid     → green  (Active / Verified / Complete)
 *   Active   → green
 *   Inactive → amber
 */
const STATUS_CONFIG = {
  Draft: {
    bg: "rgba(245,158,11,0.12)",
    color: "#f59e0b",
  },
  Approved: {
    bg: "rgba(99,102,241,0.12)",
    color: "#6366f1",
  },
  Paid: {
    bg: "rgba(16,185,129,0.12)",
    color: "#10b981",
  },
  Active: {
    bg: "rgba(16,185,129,0.12)",
    color: "#10b981",
  },
  Inactive: {
    bg: "rgba(245,158,11,0.12)",
    color: "#f59e0b",
  },
};

/** Fallback for unknown statuses */
const DEFAULT_CONFIG = {
  bg: "rgba(100,116,139,0.12)",
  color: "#64748b",
};

const SIZE_STYLES = {
  sm: {
    fontSize: "0.65rem",
    padding: "2px 8px",
  },
  md: {
    fontSize: "0.75rem",
    padding: "2px 10px",
  },
};

/**
 * PayrollStatusBadge
 *
 * Renders a pill-shaped status badge for payroll batch / template statuses.
 *
 * @param {string}  status  "Draft" | "Approved" | "Paid" | "Active" | "Inactive"
 * @param {string}  [size]  "sm" | "md" (default "md")
 */
const PayrollStatusBadge = ({ status, size = "md" }) => {
  const cfg = STATUS_CONFIG[status] ?? DEFAULT_CONFIG;
  const sizeStyle = SIZE_STYLES[size] ?? SIZE_STYLES.md;

  return (
    <span
      role="status"
      aria-label={status}
      style={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "9999px",
        fontWeight: 600,
        letterSpacing: "0.01em",
        background: cfg.bg,
        color: cfg.color,
        fontSize: sizeStyle.fontSize,
        padding: sizeStyle.padding,
        whiteSpace: "nowrap",
      }}
    >
      {status}
    </span>
  );
};

export default PayrollStatusBadge;
